<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow v-if="currentSection < 2 && !fromSimulation" :confirm="askConfirm"
                    :title="$t('Add') + ' ' + $t('a.e')  + ' ' +  $t('operation')"
                    route-back="OperationIndex"/>
        <back-arrow v-else-if="currentSection < 2 && fromSimulation" :confirm="askConfirm"
                    :params="{simulationId: simulationId}"
                    :title="$t('Add') + ' ' + $t('a.e')  + ' ' +  $t('operation')" route-back="SimulationShow"/>
        <div v-else-if="currentSection===2">
          <div class="d-flex align-items-center">
            <h1 class="page-title">{{ $t('Add') + ' ' + $t('operation.finance.emprunt') }}</h1>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">
            <div>
              <div class="col">
                <b-nav class="multi-tabs-field-navbar" hidden>
                  <b-nav-item v-for="(tab, index) in tabs" :key="index + '-nav-key'"
                              :class="{ 'link-active': currentSection === index }"
                              class="multi-tabs-field-navbar-item"
                              @click.prevent="currentSection = index">
                    <div>
                      {{ $t(tab) }}
                    </div>
                  </b-nav-item>
                </b-nav>
              </div>
            </div>
            <b-container fluid>
              <b-row>
                <b-col v-for="(tab, index) in tabs" v-if="currentSection === index" :key="index + '-content-key'">
                  <template v-if="currentSection===0">
                    <b-form v-unsave-detector @submit.stop.prevent="onSubmit">
                      <div class="row mb-4">
                        <div class="col-md-12">
                          <span class="section-title">{{ $t('operation.General.infos') }}</span>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-8">

                          <div class="row">
                            <div class="col-md-6">
                              <b-form-group
                                :invalid-feedback="form.name.invalidFeedback"
                                :label="$t('operation.Name')"
                                :state="form.name.state"
                                class="medium-label mb-4"
                                label-for="name-input">
                                <b-form-input
                                  id="name-input"
                                  v-model="form.name.value"
                                  :state="form.name.state"
                                  maxlength="250"
                                  required
                                  type="text"
                                  v-on:change="removeInvalidFeedback('name'); askConfirm=true;">
                                </b-form-input>
                              </b-form-group>
                            </div>

                            <div class="col-md-6">
                              <b-form-group
                                :invalid-feedback="form.address.invalidFeedback"
                                :label="$t('operation.Address')"
                                :state="form.address.state"
                                class="medium-label mb-4"
                                label-for="address-input">
                                <b-form-input
                                  id="address-input"
                                  v-model="form.address.value"
                                  :state="form.address.state"
                                  maxlength="250"
                                  required
                                  type="text"
                                  v-on:change="removeInvalidFeedback('address'); askConfirm=true;">
                                </b-form-input>
                              </b-form-group>
                            </div>

                            <div class="col-md-6">
                              <b-form-group
                                :invalid-feedback="form.postalCode.invalidFeedback"
                                :label="$t('operation.PostalCode')"
                                :state="form.postalCode.state"
                                class="medium-label mb-4"
                                label-for="postal-code-input">
                                <b-form-input
                                  id="postal-code-input"
                                  v-model="form.postalCode.value"
                                  :state="form.postalCode.state"
                                  maxlength="250"
                                  required
                                  type="text"
                                  v-on:change="removeInvalidFeedback('postalCode'); askConfirm=true;">
                                </b-form-input>
                              </b-form-group>
                            </div>

                            <div class="col-md-6">
                              <b-form-group
                                :invalid-feedback="form.city.invalidFeedback"
                                :label="$t('operation.City')"
                                :state="form.city.state"
                                class="medium-label mb-4"
                                label-for="city-input">
                                <b-form-input
                                  id="city-input"
                                  v-model="form.city.value"
                                  :state="form.city.state"
                                  maxlength="250"
                                  required
                                  type="text"
                                  v-on:change="removeInvalidFeedback('city'); askConfirm=true;">
                                </b-form-input>
                              </b-form-group>
                            </div>

                            <div v-if="!fromSimulation" class="col-md-6">
                              <b-form-group
                                :label="$t('Simulation')"
                                class="medium-label mb-4"
                                label-for="simulation-input">
                                <b-form-select
                                  id="simulation-input"
                                  v-model="simulationId"
                                  v-on:change="resetLots(); askConfirm=true;">
                                  <b-form-select-option :value="null">{{ $t('Aucune simulation sélectionnée') }}</b-form-select-option>
                                  <b-form-select-option v-for="simulation in simulations" :value="simulation.id">
                                    {{ $t(simulation.name) }}
                                  </b-form-select-option>
                                </b-form-select>
                              </b-form-group>
                            </div>

                            <div class="col-md-6 mt-2">
                              <b-form-group
                                :label="$t('operationConstruction.operationType')"
                                class="medium-label mb-4"
                                label-for="uniteConstruction-input">
                                <b-form-select
                                  id="uniteConstruction-input"
                                  v-model="form.operationType.value"
                                  v-on:change="manageOperationType"
                                  required>
                                  <b-select-option v-for="(operation, index) in operationTypes" :key="index"
                                          :value="operation.value">
                                    {{ $t(operation.text) }}
                                  </b-select-option>
                                </b-form-select>
                              </b-form-group>
                            </div>

                            <div class="col-md-6">
                              <b-form-group
                                :invalid-feedback="form.estimatedStartDate.invalidFeedback"
                                :label="$t('operation.DateStart.label')"
                                :state="form.estimatedStartDate.state"
                                class="medium-label mb-4"
                                label-for="estimatedStartDate-input">
                                <datepicker-input
                                  id="estimatedStartDate-input"
                                  v-model="form.estimatedStartDate.value"
                                  :state="form.estimatedStartDate.state"
                                  required
                                  @input="removeInvalidFeedback('estimatedStartDate');">
                                </datepicker-input>
                              </b-form-group>
                            </div>
                            <div class="col-md-6">
                              <b-form-group
                                :invalid-feedback="form.estimatedEndDate.invalidFeedback"
                                :label="$t('operation.DateEnd.label')"
                                :state="form.estimatedEndDate.state"
                                class="medium-label mb-4"
                                label-for="estimatedEndDate-input">
                                <datepicker-input
                                  id="estimatedEndDate-input"
                                  v-model="form.estimatedEndDate.value"
                                  :state="form.estimatedEndDate.state"
                                  required
                                  @input="removeInvalidFeedback('estimatedEndDate');">
                                </datepicker-input>
                              </b-form-group>
                            </div>

                            <div class="col-md-6">
                              <b-form-group
                                :invalid-feedback="form.constructionStartDate.invalidFeedback"
                                :state="form.constructionStartDate.state"
                                class="medium-label mb-4"
                                label-for="constructionStartDate-input">

                                <b-tooltip html target="info-circle-construction-start" variant="dark">
                                  {{ $t('operation.constructionStartDate.info') }}
                                </b-tooltip>
                                <label id="constructionStartDate-label" for="constructionStartDate-input">{{
                                    $t('operation.constructionStartDate.label')
                                  }}</label>
                                <b-icon id="info-circle-construction-start" class="ml-2" icon="info-circle"
                                        variant="primary"></b-icon>

                                <datepicker-input
                                  id="constructionStartDate-input"
                                  v-model="form.constructionStartDate.value"
                                  :state="form.constructionStartDate.state"
                                  required
                                  @input="removeInvalidFeedback('constructionStartDate');">
                                </datepicker-input>
                              </b-form-group>
                            </div>

                            <div class="col-md-6">
                              <b-form-group
                                :invalid-feedback="form.constructionEndDate.invalidFeedback"
                                :state="form.constructionEndDate.state"
                                class="medium-label mb-4"
                                label-for="constructionEndDate-input">

                                <b-tooltip html target="info-circle-construction-end" variant="dark">
                                  {{ $t('operation.constructionEndDate.info') }}
                                </b-tooltip>
                                <label id="constructionEndDate-label" for="constructionEndDate-input">{{
                                    $t('operation.constructionEndDate.label')
                                  }}</label>
                                <b-icon id="info-circle-construction-end" class="ml-2" icon="info-circle"
                                        variant="primary"></b-icon>


                                <datepicker-input
                                  id="constructionEndDate-input"
                                  v-model="form.constructionEndDate.value"
                                  :state="form.constructionEndDate.state"
                                  required
                                  @input="removeInvalidFeedback('constructionEndDate');">
                                </datepicker-input>
                              </b-form-group>
                            </div>


                            <div class="col-md-6">
                              <b-form-group
                                :invalid-feedback="form.acteAchat.invalidFeedback"
                                :state="form.acteAchat.state"
                                class="medium-label mb-4"
                                label-for="acteAchat-input">

                                <b-tooltip html target="info-circle-acte-achat" variant="dark">
                                  {{ $t('operation.acteAchat.info') }}
                                </b-tooltip>
                                <label id="acteAchat-label"
                                       for="acteAchat-input">{{ $t('operationPlanning.operation.acte.achat') }}</label>
                                <b-icon id="info-circle-acte-achat" class="ml-2" icon="info-circle"
                                        variant="primary"></b-icon>

                                <datepicker-input
                                  id="acteAchat-input"
                                  v-model="form.acteAchat.value"
                                  :state="form.acteAchat.state"
                                  required
                                  @input="removeInvalidFeedback('acteAchat');">
                                </datepicker-input>
                              </b-form-group>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <b-form-group
                            class="medium-label mb-4">
                            <div class="d-flex">
                              <label for="picture-input">
                                {{ $t('operation.Picture') }}
                              </label>
                              <span class="ml-1">{{ $t('f.facultative.for.label') }}</span>
                            </div>
                            <custom-form-file
                              v-model="form.picture.value"
                              id="picture-input"
                              :drop-placeholder="$t('drop-placeholder')"
                              accept=".png, .jpeg, .jpg"
                              placeholder=""
                              @preview="imagePreview = $event"
                            />
                            <div v-if="imagePreview" class="position-relative mt-1">
                              <img :src="imagePreview" alt="Image preview" class="preview-image"/>
                            </div>
                          </b-form-group>
                        </div>

                      </div>

                      <template v-if="form.operationType.value && form.operationType.value !== 'DEFAULT'">
                        <div class="row mb-4">
                          <div class="col-md-12">
                            <div class="d-flex flex-column">
                              <span class="section-title">{{
                                  $t('operation.General.VIRVEFA', {type: form.operationType.value})
                                }}</span>
                              <span class="virvefa-subtitle mt-1">{{ $t('operation.General.VIRVEFA.subtitle') }}</span>
                            </div>

                            <schedule-vir-vefa :initial-schedule="form.schedule.value" :need-amount-preview="false"
                                               @schedule-changed="scheduleChanged"></schedule-vir-vefa>

                          </div>
                        </div>
                      </template>


                      <div class="d-flex justify-content-end">
                        <b-button type="submit" variant="primary">
                          {{ $t('Validate') }}
                        </b-button>
                      </div>
                    </b-form>
                  </template>
                  <template v-if="currentSection=== 1">
                    <b-form v-unsave-detector @submit.stop.prevent="onSubmit">
                      <operation-lots
                        :need-schedule="form.operationType.value && form.operationType.value !== 'DEFAULT'"
                        :template-schedule="form.schedule.value"
                        :key="simulationId"
                        ref="operationLots"
                        :types-lot="typesLot"
                        :operation-type="form.operationType.value"
                        :operationLots="form.lotsValues"
                        :override-current-section="overrideCurrentSection"
                        :simulation-id="simulationId">
                      </operation-lots>


                      <div class="d-flex justify-content-end">
                        <b-button class="mr-2" type="button" variant="outline-primary" @click="addOperationLot()">
                          {{ $t('operationLot.Add') }}
                        </b-button>
                        <b-button type="submit" variant="primary">
                          {{ $t('Validate') }}
                        </b-button>
                      </div>
                    </b-form>
                  </template>
                  <template v-if="currentSection === 2 ">
                    <OperationCreateEmprunt :key="operationId"
                                            :acte-achat="form.acteAchat.value"
                                            :amount="amount"
                                            :duration="duration"
                                            :interest="interest"
                                            :operation-id="operationId"
                                            :operation-name="operationName"/>
                  </template>
                </b-col>

              </b-row>
            </b-container>
          </b-card>
        </div>
      </div>
    </b-container>

  </div>
</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import OperationLots from "./components/OperationLots"
import OperationCreateEmprunt from "../operationEmprunt/OperationCreateEmprunt"
import DatepickerInput from '../../components/b122/editFields/DatepickerInput'
import ScheduleVirVefa from "./components/ScheduleVirVefa";
import CustomFormFile from "../../components/b122/editFields/CustomFormFile.vue";


export default {

  name: 'OperationCreate',


  components: {
    BackArrow,
    OperationLots,
    OperationCreateEmprunt,
    DatepickerInput,
    ScheduleVirVefa,
    CustomFormFile
  },

  data() {
    return {
      simulationId: this.$route.params.simulationId || null,
      fromSimulation: this.$route.params.fromSimulation,
      simulations: [],
      operationTypes: [],
      currentSection: 0,
      lotLimit: -1,
      typesLot: [],
      operationId: null,
      amount: 0,
      duration: 0,
      interest: 0,
      overrideCurrentSection: null,
      operationName: null,
      tabs: ["Informations générales", "Lots", "Emprunt Bancaire"],
      form: {
        name:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        address:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        postalCode:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        city:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        picture:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        schedule:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        estimatedStartDate:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        estimatedEndDate:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        operationType:
          {
            state: null,
            invalidFeedback: null,
            value: 'DEFAULT'
          },
        acteAchat:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        constructionStartDate:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        constructionEndDate:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        lotsValues: []
      },
      isEstateAgent: this.$store.getters.isEstateAgent,
      isCollaborator: this.$store.getters.isCollaborator,
      isCollaboratorPlus: this.$store.getters.isCollaboratorPlus,
      imagePreview: null,
      askConfirm: false,
      nbOperations: null,
      endFreeAccess: null,
      subscriptionType: null,
      currentUserSubscription: null,
    }
  },


  async mounted() {
    const canCreate = await this.checkIfCanCreateNewOperation();
    if (!canCreate) {
      this.redirectToOperationIndex();
    } else {
      await this.fetchData();
    }
  },

  methods: {

    async checkIfCanCreateNewOperation() {
      try {
        const response = await api.get('/operation/checkIfCanCreateNewOperation');
        return response.data.canCreate;
      } catch (error) {
        return false;
      }
    },

    async redirectToOperationIndex() {
      this.$router.push({
        name: 'OperationIndex',
        params: {
          popUp: true
        }
      });
    },

    getFileUrl(itemUrl) {
      return process.env.SERVER_URL + itemUrl
    },

    resetLots() {
      this.form.lotsValues = []
    },

    async fetchData() {
      await this.getMaxNbLots()
      await this.fetchUserInfos()
      if (this.simulationId != null) {
        await this.fetchDataSimulation()
      } else {
        await this.fetchAllSimulations()
      }
      await this.fetchAllOperations()
      await this.fetchOperationTypes()
      await this.getTypesLot()
    },

    async getTypesLot() {
      await api
        .get(`/operationLot/getTypesLot`)
        .then(response => {
          this.typesLot = response.data
        })
    },

    async fetchUserInfos() {
      await api
        .get(`/user/getUserInfos`)
        .then(async response => {
          this.endFreeAccess = response.data.endFreeAccess
          this.subscriptionType = response.data.subscriptionType
          this.currentUserSubscription = response.data.hasOwnProperty('currentUserSubscription') ? response.data.currentUserSubscription : null
          this.nbOperations = response.data.nbOperationsAnniversary
        })
    },

    async getMaxNbLots() {
      await api
        .get(`/operationLot/getMaxNbLots`)
        .then(response => {
          this.lotLimit = response.data
          console.log("lotLimit", this.lotLimit)
        })
    },

    addOperationLot() {

      if (this.lotLimit > -1 && this.form.lotsValues.length >= this.lotLimit) {
        this.errorToast("abonnement.limit.lots")
        return
      }

      this.form.lotsValues.push({
        name:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        prixParM2:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        prixVenteTTC:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        typeLot:
          {
            state: null,
            invalidFeedback: null,
            value: this.typesLot[0].value
          },
        surface:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        lotCoPro:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        etage:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        comment:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        debutConstruction: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        finConstruction: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        acteVente: {state: null, invalidFeedback: null, value: null},
        sspVente: {state: null, invalidFeedback: null, value: null},
        realDate: {state: null, invalidFeedback: null, value: null},
        realDateSSP: {state: null, invalidFeedback: null, value: null},
        percentageTreso: {state: null, invalidFeedback: null, value: null},
        pretAcheteur: {state: null, invalidFeedback: null, value: null},
        depotPermis: {state: null, invalidFeedback: null, value: null},
        accordPermis: {state: null, invalidFeedback: null, value: null},
        isLoue: {state: null, invalidFeedback: null, value: false},
        nomLocataire: {state: null, invalidFeedback: null, value: null},
        dateFinBail: {state: null, invalidFeedback: null, value: null},
        dateButoirResiliation: {state: null, invalidFeedback: null, value: null},
        loyersPercus: {state: null, invalidFeedback: null, value: null},
        tauxTVA: {state: null, invalidFeedback: null, value: null},
        isLotVir: {state: null, invalidFeedback: null, value: false},
        schedule: {
          state: null,
          invalidFeedback: null,
          value: null
        },

      })

      this.currentSection = this.operationLots.length - 1

      this.$nextTick(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });

      this.successToastAddLot()
    },


    successToastAddLot() {
      this.$bvToast.toast(this.$i18n.t("operationLot.Added"), {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    },


    async fetchDataSimulation() {
      api
        .get(`/simulation/${this.simulationId}`)
        .then(response => {
          this.form.name.value = response.data.name
          this.amount = response.data.bankCredit.amount
          this.duration = response.data.bankCredit.duration
          this.interest = response.data.bankCredit.interest
        })
        .catch((error) => {
          this.$router.push({
            name: 'SimulationShow',
            params: {
              simulationId: this.simulationId,
              message: error.response.data.message
            }
          })
        })
    },

    async fetchAllSimulations() {
      api
        .get('/simulation/getAllAuthorizedSimulationsWithoutOperation')
        .then(response => {
          this.simulations = response.data
          this.simulations.sort((a, b) => {
            return a.name.localeCompare(b.name)
          })
        })
    },

    async fetchAllOperations() {
      api
        .get('/operation/getAllAuthorizedOperations')
        .then(response => {
          this.nbOperations = response.data.length
        })
    },

    async fetchOperationTypes() {
      api
        .get('/operation/getAllOperationTypes')
        .then(response => {
          this.operationTypes = response.data
        })
    },

    onSubmit() {
      if (this.currentSection === 0 && this.simulationId == null) {
        this.$confirm(this.$i18n.t('Confirm.create.operation.without.simulation').toString()).then(() => {
          this.saveOperation()
        });
      } else {
        this.saveOperation()
      }
    },

    async manageOperationType() {
      if (this.form.operationType.value !== "DEFAULT") {
        api({
          method: 'GET',
          url: '/user/canUseVirVefa',
        }).then((response) => {
          if (!response.data.virVefaEnabled) {
            this.form.operationType.value = "DEFAULT"
            this.showCustomConfirm(
              this.$i18n.t('virVefa.message').toString(),
              this.$i18n.t('Ok')
            );
          }
        })
      }
      await this.getTypesLot()
      if(this.form.operationType.value === "VEFA"){
        this.typesLot = this.typesLot.filter(type => type.isVefa === true)
      } else {
        this.typesLot = this.typesLot.filter(type => type.isVir === true)
      }
    },

    showCustomConfirm(message, okText) {

      return new Promise((resolve) => {
        this.$bvModal.msgBoxOk(message, {
          okTitle: okText,
          centered: true,
          okVariant: 'primary'
        })
          .then((confirmed) => {
            resolve(confirmed);
          })
          .catch(() => {
            resolve(false);
          });
      });
    },

    scheduleChanged(schedule, isValid) {
      this.form.schedule.state = isValid
      this.form.schedule.invalidFeedback = null
      this.form.schedule.value = schedule
    },

    saveOperation() {
      if(this.form.operationType.value === "DEFAULT"){
        this.form.schedule.state = null
        this.form.schedule.invalidFeedback = null
        this.form.schedule.value = null
      }
      const fieldInvalid = Object.keys(this.form).find(key => this.form[key].state === false);

      if (fieldInvalid) {
        this.scrollToElement(fieldInvalid);
        return;
      }

      this.overrideCurrentSection = null
      let data = new FormData()
      data.append('name', this.form.name.value)
      data.append('address', this.form.address.value)
      data.append('postalCode', this.form.postalCode.value)
      data.append('city', this.form.city.value)
      data.append('picture', this.form.picture.value)
      data.append('simulationId', this.simulationId)
      if (this.form.estimatedStartDate.value != null) {
        data.append('estimatedStartDate', this.form.estimatedStartDate.value)
      }
      if (this.form.estimatedEndDate.value != null) {
        data.append('estimatedEndDate', this.form.estimatedEndDate.value)
      }
      if (this.form.constructionStartDate.value != null) {
        data.append('constructionStartDate', this.form.constructionStartDate.value)
      }
      if (this.form.constructionEndDate.value != null) {
        data.append('constructionEndDate', this.form.constructionEndDate.value)
      }
      if (this.form.acteAchat.value != null) {
        data.append('acteAchat', this.form.acteAchat.value)
      }
      let lotsValuesFormatted = []
      for (const lot of this.form.lotsValues) {
        const index = this.form.lotsValues.indexOf(lot)
        let lotValues = {
          'lotNumber': (index + 1),
          'name': lot.name.value,
          'prixVenteTTC': lot.prixVenteTTC.value,
          'prixParM2': lot.prixParM2.value,
          'typeLot': lot.typeLot.value,
          'surface': lot.surface.value,
          'acteVente': lot.acteVente.value,
          'sspVente': lot.sspVente.value,
          'debutConstruction': lot.debutConstruction.value,
          'finConstruction': lot.finConstruction.value,
          'percentageTreso': lot.percentageTreso.value,
          'pretAcheteur': lot.pretAcheteur.value,
          'depotPermis': lot.depotPermis.value,
          'accordPermis': lot.accordPermis.value,
          'realDate': lot.realDate.value,
          'realDateSSP': lot.realDateSSP.value,
          'isLoue': lot.isLoue.value,
          'nomLocataire': lot.nomLocataire.value,
          'dateFinBail': lot.dateFinBail.value,
          'dateButoirResiliation': lot.dateButoirResiliation.value,
          'loyersPercus': lot.loyersPercus.value,
          'tauxTVA': lot.tauxTVA.value,
          'isLotVir': lot.isLotVir.value,
          'schedule': lot.schedule.value,
        }
        let comment = lot.comment.value
        if (comment != null) {
          lotValues['comment'] = comment
        }
        lotsValuesFormatted.push(lotValues)
      }
      data.append('lots', JSON.stringify(lotsValuesFormatted))
      data.append('currentSection', this.currentSection)
      data.append('operationType', this.form.operationType.value)
      data.append('schedule', JSON.stringify(this.form.schedule.value))


      api({
        method: 'POST',
        url: `operation`,
        data: data
      })
        .then(response => {
          this.operationId = response.data.id;
          this.operationName = response.data.tostring;
          this.$nextTick(function () {
            if ((this.isCollaborator || this.isCollaboratorPlus) && this.currentSection === 1) {
              this.generateMonthlyCharges()
              this.$router.push({
                name: 'OperationShow',
                params: {
                  operationId: this.operationId,
                  currentSection: 0
                }
              }, () => {
                this.$nextTick(() => {
                  this.successToast(this.operationName)
                })
              })
            } else {
              this.currentSection++
            }
          });

        })
        .catch((error) => {
          this.overrideCurrentSection = null
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
              params: {
                message: error.response.data.message
              }
            })
          } else if (error.response.status === 403) {
            const invalidField = error.response.data.invalidField
            if (invalidField === "create") {
              this.errorToast(error.response.data.message)
              return
            }
            let invalidLotNumber
            if (invalidField === "lotsValues") {
              const invalidLotNumber = parseInt(error.response.data.invalidLotNumber) - 1
              const invalidSubField = error.response.data.invalidSubField
              this.form["lotsValues"][invalidLotNumber][invalidSubField]['state'] = false
              this.form["lotsValues"][invalidLotNumber][invalidSubField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)
              if(this.$refs.operationLots.currentSection !== invalidLotNumber){
                this.overrideCurrentSection = invalidLotNumber
              }
              this.$nextTick(() => {
                this.$nextTick(() => {
                  setTimeout(() => {
                    this.scrollToElement(invalidSubField, invalidLotNumber ? invalidLotNumber : 0);
                  }, 300); // Délai plus long
                });
              });
              return
            }
            this.form[invalidField]['state'] = false
            this.form[invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)
            if(invalidField){
              this.$nextTick(() => {
                this.scrollToElement(invalidField);
              });
            }

          }
        })
    },

    async generateMonthlyCharges() {

      let data = new FormData()
      data.append('operationId', this.operationId)

      api({
        method: 'POST',
        url: '/treasury/generateMonthlyCharges',
        data: data
      })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationShow',
              params: {
                operationId: this.operationId,
                currentSection: 0,
                message: error.response.data.message
              }
            })
          }
        })
    },

    scrollToElement(fieldId, index = null) {
      const attemptScroll = (attempts = 0) => {
        if (attempts > 10) return;

        this.$nextTick(() => {
          let element;
          if (index != null) {
            element = document.querySelector(`#${fieldId}-input-${index}`);
          } else {
            element = document.querySelector(`#${fieldId}-input`);
          }

          if (element) {
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            });
          } else {
            setTimeout(() => attemptScroll(attempts + 1), 100);
          }
        });
      };

      attemptScroll();
    },

    removeInvalidFeedback(field) {
      this.form[field]['state'] = null
    },

    errorToast(message) {
      this.$bvToast.toast(this.$i18n.t(message), {
        autoHideDelay: 5000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "danger",
        solid: true,
      })
    },

    successToast(operationName) {
      this.$bvToast.toast(this.$i18n.t('Operation') + ' "' + operationName + '" ' + this.$i18n.t('f.added'), {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    }

  }
}
</script>

<style scoped>
.virvefa-subtitle {
  color: var(--grey);
  font-weight: 500;
  font-size: 12px;
  line-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/operation/OperationCreate.vue